export default [
    {
        path: "/callNumberUsedRecord/list",
        component: (r) => require(["./List.vue"], r)
    },
    {
        path: "/callNumberUsedRecord/statistics",
        component: (r) => require(["./statistics.vue"], r)
    }
]


// WEBPACK FOOTER //
// ./src/modules/callNumberUsedRecord/router.js